import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  setDoc,
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy, 
  limit as limitTo,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from './firebase';

// Servicio de documentos
export const documentsService = {
  // Obtener todos los documentos de una carpeta
  getDocumentsByFolder: async (folderId) => {
    try {
      const q = query(
        collection(db, 'documents'),
        where('folderId', '==', folderId),
        orderBy('lastUpdated', 'desc')
      );
      
      const querySnapshot = await getDocs(q);
      const documents = [];
      
      querySnapshot.forEach((doc) => {
        documents.push({
          id: doc.id,
          ...doc.data()
        });
      });
      return documents;
    } catch (error) {
      console.error('❌ Error al obtener documentos:', error);
      throw error;
    }
  },

  // Obtener un documento por ID
  getDocumentById: async (documentId) => {
    try {
      const docRef = doc(db, 'documents', documentId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return {
          id: docSnap.id,
          ...docSnap.data()
        };
      } else {
        throw new Error('Documento no encontrado');
      }
    } catch (error) {
      console.error('Error al obtener documento:', error);
      throw error;
    }
  },

  // Crear un nuevo documento
  createDocument: async (documentData) => {
    try {
      const docRef = await addDoc(collection(db, 'documents'), {
        ...documentData,
        createdAt: serverTimestamp(),
        lastUpdated: serverTimestamp()
      });
      
      return {
        id: docRef.id,
        ...documentData
      };
    } catch (error) {
      console.error('Error al crear documento:', error);
      throw error;
    }
  },

  // Actualizar un documento
  updateDocument: async (documentId, documentData) => {
    try {
      const docRef = doc(db, 'documents', documentId);
      try {
        await updateDoc(docRef, {
          ...documentData,
          lastUpdated: serverTimestamp()
        });
      } catch (e) {
        // Si no existe, crearlo
        await setDoc(docRef, {
          ...documentData,
          createdAt: serverTimestamp(),
          lastUpdated: serverTimestamp()
        });
      }
      
      return {
        id: documentId,
        ...documentData
      };
    } catch (error) {
      console.error('Error al actualizar documento:', error);
      throw error;
    }
  },

  // Eliminar un documento
  deleteDocument: async (documentId) => {
    try {
      const docRef = doc(db, 'documents', documentId);
      await deleteDoc(docRef);
      return true;
    } catch (error) {
      console.error('Error al eliminar documento:', error);
      throw error;
    }
  },

  // Buscar documentos
  searchDocuments: async (searchQuery, folderId = null) => {
    try {
      let q = collection(db, 'documents');
      
      if (folderId) {
        q = query(q, where('folderId', '==', folderId));
      }
      
      const querySnapshot = await getDocs(q);
      const documents = [];
      
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        const searchText = `${data.title} ${data.description} ${data.tags?.join(' ')}`.toLowerCase();
        
        if (searchText.includes(searchQuery.toLowerCase())) {
          documents.push({
            id: doc.id,
            ...data
          });
        }
      });
      
      return documents;
    } catch (error) {
      console.error('Error al buscar documentos:', error);
      throw error;
    }
  },

  // Obtener documentos recientes
  getRecentDocuments: async (maxCount = 10) => {
    try {
      const q = query(
        collection(db, 'documents'),
        orderBy('lastUpdated', 'desc'),
        limitTo(maxCount)
      );
      
      const querySnapshot = await getDocs(q);
      const documents = [];
      
      querySnapshot.forEach((doc) => {
        documents.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      return documents;
    } catch (error) {
      console.error('Error al obtener documentos recientes:', error);
      throw error;
    }
  }
};

export default documentsService;
